export const locale = {
    lang: 'es',
    data: {
      'PRINCIPAL': {
        'TITULO': 'Estatus de encuestas',
        'SUBTITULO': 'Puede revisar y dar seguimiento a la información de las encuestas aplicadas en uno o más productos de la empresa',
        'COPY_URL_RES':'Copiar URL de SuccesGo',

      },
      'MENU_PRODUCTOS': {
        'TITULO': 'Productos adquiridos',
        'CARGANDO': 'Cargando lista de productos',
        'NOMBREPULSO': 'Pulso',
        'TIPOS': {
          'certificar': {
            'NOMBRE': 'Certificar',
            'SUBTIPOS': {
              'v1': 'Certificar v1',
              'v2': 'Certificar v2.0',
              'v3': 'Certificar v3.0',
            }
          },
          'certificacionesAdicio': {
            'NOMBRE': 'Certificaciones adicionales',
            'SUBTIPOS': {
              'v1Amco': 'AMCO',
              'v2TD': 'Trabajo digno',
              'v3PE': 'Primer empleo',
            }
          },
          'medir': {
            'NOMBRE': 'Medir',
            'SUBTIPOS': {
              'v1': 'Medir v1',
              'v2': 'Medir mejorado',
              'v3': 'Medir + MST',
              'v4': 'Medir por áreas',
              'v5': 'Medir por líderes',
              'v6': 'Medir por dimensiones',
              'v7': 'Medir para certificar',
              'v8': 'Medir 3.0',
            }
          },
          'pulse': {
            'NOMBRE': 'Pulse Check',
            'SUBTIPOS': {
              'v1': 'Pulse Check v1.0',
              'v2': 'Pulse Check v3.0',
            }
          },
          'focus': {
            'NOMBRE': 'Focus Area',
            'SUBTIPOS': {
            }
          },
          'nom35': {
            'NOMBRE': 'NOM-035',
            'SUBTIPOS': {
              'v1': 'NOM-035',
              'v2': 'NOM-035 v3',
            }
          },
          'cgoExpress': {
            'NOMBRE': 'Cultural Go Express',
            'SUBTIPOS': {
              'cgoExpress': 'Cultural Go Express'
            }
          },
          'medir_amco': {
            'NOMBRE': 'Productos ICI',
            'SUBTIPOS': {
              'v1': 'ICI',
            }
          },
          'resulGoFlow': {
            'NOMBRE': 'Resultados goFlow',
            'SUBTIPOS': {
              'resulGoFlow': 'Resultados goFlow'
            }
          },
          'swift': {
            'NOMBRE': 'Swift',
            'SUBTIPOS': {
              'swift': 'Swift'
            }
          }
        }
      },
      'DETALLES': {
        'TITULO': 'Detalles del producto',
        'PRODUCTO': 'Producto: ',
        'PROGRESO': 'Progreso',
        'RESTANTE': 'Tiempo restante',
        'DIASREST': 'Días restantes: ',
        'PANELFIJO': 'Mostrar como panel fijo',
        // 'SURVEYTOKEN': 'Token de encuesta',
        'SURVEYTOKEN': 'SurveyToken',
        'ACCOUNT_ID': 'ID cuenta',
        'OPORTUNITY_ID': 'ID oportunidad',

        'FECHAS': {
          'lanzamiento': 'Fecha de lanzamiento',
          'cierre': 'Fecha de cierre',
          'prorroga': 'Fecha de prorroga',
          'recordatorio':'Recordatorios',
          'avisos':'Comunicación pre encuesta',
        },
        'AVANCES': {
          'NORMAL': 'Avance de respuestas: ',
          'MAS50': 'Avance más de 50: ',
          'MAS50_2': 'Más de 50 - Avance de respuestas',
          'MENOS50': 'Avance menos de 50: ',
          'MENOS50_2': 'Menos de 50 - Avance de respuestas'
        }
      },
      'CONTENIDO': {
        'BOTONES': {
          'VERPROD_1': 'Elegir un producto',
          'VERPROD_2': 'Ver otro producto',
          'OCULTAR': 'Ocultar'
        },
        'PREVIA': {
          'TITULO': 'Estado de encuesta por producto',
          'SUBTITULO': 'En el menú de la izquierda en esta pantalla se muestra la lista de productos adquiridos por esta empresa. Para ver el estado de la encuesta perteneciente a cada producto, haga clic en una categoría de producto y posteriormente elija un año. Tras esto, se mostrarán los detalles de la encuesta seleccionada, sólo en caso de que el producto seleccionado ya cuente con una encuesta inicializada.',
          'CARGANDO': 'Recuperando estado del producto seleccionado, espere por favor'
        },
        'ESTADOS': {
          'NOCREADA': 'Este producto aún no tiene una encuesta creada',
          'NOINICIADA': 'Encuesta no habilitada'
        },
      },
      'COLABORADORES': {
        'TAB': 'Lista de colaboradores',
        'CARGANDO': 'Cargando lista de colaboradores',
        'TABLA': {
          'TITULO': 'Lista de colaboradores',
          'NOINFO': 'Sin información',
          'COLUMNAS': {
            'NOMBRE': 'Nombre completo',
            'EMAIL': 'Correo electrónico',
            'PASS': 'Clave de acceso',
            'STATUS': 'Estado actual',
            'FECHA_INI': 'Fecha de inicio',
            'FECHA_FIN': 'Fecha de finalización',
            'ACCIONES': 'Acciones'
          },
          'TOOLTIPS': {
            'ACCIONES': 'Acciones disponibles',
            'EMAILS': 'Registro de correos',
          },
        },
        'ACCIONES': {
          'TITULO': 'Acciones disponibles',
          'LISTA': {
            'primerosColab': 'Ver primeros 1000',
            'buscarColab': 'Buscar colaborador',
            'nuevoColab': 'Agregar nuevo colaborador',
            'enviaReco': 'Enviar recordatorios',
            'bajarColab': 'Descargar lista de colaboradores',
          }
        },
        'SENDGRID': {
          'TITULO': 'Registro de correos enviados',
          'SUBTITULO': 'Elija un tipo de asunto de la lista para mostrar el historial de correos enviados',
          'SELOPC': 'Seleccione una opción',
          'INFOASUNTO': {
            'TITULO': 'Información del correo',
            'CARD': {
              'from': 'Enviado a',
              'to': 'De',
              'subject': 'Asunto'
            },
            'HISTORIAL': {
              'TITULO': 'Historial de envíos',
              'SUBTITULO': 'NOTA: La fecha / hora que se muestra en la lista se establece en la hora local de',
              'VECESABIERTO': 'Veces abierto',
              'ULTIMOEVENTO': 'Último evento',
              'NORECORDS': 'No se cuenta con su historial de correo!',
              'STATUS': {
                'ABIERTO': 'Correo enviado',
                'NOENVIADO': 'Aún no enviado'
              }
            }
          },
          'BOTONES': {
            'BACK': 'Regresar'
          }
        },
        'ACCIONESUSUARIO': {
          'TITULO': 'Acciones disponibles',
          'SUBTITULO': 'La siguiente lista muestra la lista de acciones disponibles para el usuario',
          'CARGANDO': 'Cargando acciones disponibles',
          'LISTA': {
            'modificar': 'Modificar los datos del colaborador seleccionado',
            'borrar': 'Borrar el colaborador seleccionado',
            'invitacion': 'Reenviar invitación' ,
            'recordatorio': 'Reenviar recordatorio',
            'respuestas': 'Eliminar respuesta de la encuesta' ,
            'resetSur': 'Resetear acceso a la encuesta',
          }
        },
        'MODALES': {
          'BUSCAR': 'Ingrese el nombre del colaborador a buscar',
          'BUSCAR_BOT': 'Buscar',
          'MINIMARECO': 'Sólo se pueden enviar recordatorios a partir de la fecha de lanzamiento de la encuesta',
          'GENERAEXCEL': 'Generando archivo excel de colaboradores, espere un momento',
          'NOANSWERS': 'No se encontraron las respuestas de este colaborador',
          'ENVIOCORREO': 'Enviando el mensaje, espere un momento',
          'BORRARESP': 'Eliminando respuestas de este usuario, espere un momento',
        },
        'EXCEL': {
          'TITUARCHIVO': 'Lista de colaboradores',
          'COLUMNAS': {
            'name': 'Nombre del colaborador',
            'email': 'Correo electrónico',
            'id_status': 'Estatus de encuesta',
            'start_date': 'Fecha de inicio',
            'end_date': 'Fecha de finalización',
          }
        }
      },
      'ACCIONES': {
        'TAB': 'Acciones',
        'TITULO': 'Lista de acciones disponibles por categoría',
        'CATEGORIAS': {
          'encuesta': 'Encuesta',
          'filemanager': 'Gestor de archivos',
          'resultados': 'Resultados',
          'cultureaudit': 'Culture Audit',
          'webcompro':'Perfil de la empresa en la web'
        },
        'LISTA': {
          'surveyCheck': 'Comprobación de la encuesta',
          'surveyDown': 'Descargar encuesta',
          'goSurvey': 'Ir a la encuesta',
          'goCounting': 'Ir al portal de conteos',
          'goCounting_more50': 'Ir al portal de conteos +50',
          'goCounting_less50': 'Ir al portal de conteos -50',
          'genCountingUrl': 'Generar enlace externo al portal de conteos',
          'copyCountingUrl': 'Copiar enlace externo al portal de conteos',
          'updateCounting': 'Sincronizar con portal de conteos',
          'addPro': 'Añadir prorroga',
          'verRecord': 'Recordatorios registrados',
          'surveyClose': 'Cerrar encuesta',
          'surveyOpen': 'Abrir encuesta',
          'processRes': 'Procesar resultados',
          'goPriv': 'Ver carpeta privada',
          'goPub': 'Ver carpeta pública',
          'masterTable': 'Comprobación de master table',
          'verRes': 'Ver resultados',
          'upNameIcon': 'Actualizar nombre y logo',
          'regCertifi': 'Regenerar certificado',
          'goSurveyMas50': 'Ir a la encuesta +50',
          'goSurveyMenos50': 'Ir a la encuesta -50',
          'auditMan': 'Auditoría manual',
          'libeCultureBrief': 'Liberación de Culture Brief',
          'lockRes': 'Bloquear resultados',
          'verCultureAudit': 'Ver Culture Audit',
          'verAvisos':'Comunicación pre encuesta',
          'enviaCorreos': 'Enviar correos manualmente',
          'verWebComPro': 'Ver perfil de la empresa en la web',
          'verFechIniCie': 'Fecha de inicio / termino',
          'cancelarEnvios': 'Cancelar envío de correos',
          'verConfigResult': 'Configuración de resultados',
          'descaDemo': 'Permitir descargar demograficos',
          'crearClave':'Generar clave al perfil de la empresa externo',
          'copyClave':'Copiar clave al perfil de la empresa externo',
          'verDatWPC':'Ver datos de acceso al perfil de la empresa externo',
          'confirReviCultureAudit':'Confirmar revisión de Culture Audit',
          'cambiaCultureBrief': 'Asociación de Culture Audit Brief'
        },
        'MODALES': {
          'URL': 'Se copio el enlace al portapapeles',
          'URL_CLA': 'Se copio la clave al portapapeles',
          'CHANGE_RESULT':'Cargando resultados',
          'LOADINGMASTER': 'Recuperando información de la Master Table, espere un momento',
          'CONFIR_UPDA_NAM':'¿Estas seguro de actualizar el nombre y el logo?',
          'CONFIR_REG_CERT':'¿Está seguro de regenerar certificado?',
          'SUCC_UPDA_NAME':'Se ha actualizado correctamente',
          'UPDA_NAME_ICON':'Actualizando datos',
          'UPDA_STA_ENC':'Actualizando estatus de encuesta',
          'OBT_DAT_AUD_AUT':'Obteniendo información de auditoría',
          'WARNI_NOT_EXIT_TOKEN':'Error: el token no existe en MT',
          'CONFIR_REPRO_RESULT':'¿Está seguro de reprocesar los resultados?',
          'MOD_INGRE_COD_PT1':'<span> Para confirmar, ingrese el codigo en rojo en la caja de texto ',
          'MOD_INGRE_COD_PT2':'</span>',
          'ERROR_CODIGO': 'El codigo ingresado, no coincide con el indicado en rojo',
          'CONFIR_LIBE_CULT_BRI':'¿Está seguro de liberar el culture brief?',
          'CONFIR_REVI_CULT_AUDIT':'¿Está seguro de confirmar la revisión de Culture Audit?',
          'NO_CONFIR_REVI_CULT_AUDIT':'¿Está seguro de cancelar la revisión de Culture Audit?',
          'NO_CULT_BRI_ASOC':'No se encontro un culture audit asociado',
          'BLOQUEAR_1_1': 'Los resultados están desbloqueados actualmente\n¿Desea bloquear los resultados?',
          'BLOQUEAR_1_2': 'Escriba la razón por la cuál se han bloqueado los resultados',
          'BLOQUEAR_2_1': 'Los resultados están bloqueados actualmente\n¿Desea desbloquear los resultados?',
          'BLOQUEAR_2_2': 'Escriba la razón por la cuál se han desbloqueado los resultados',
          'BLOQUEAR_3_1': 'Es necesario especificar la razón del cambio',
          'SINCRONIZARMT': 'Se están sincronizando los datos de la Master Table, espere un momento',
          'UPDA_DAT_RECOR': 'Actualizando fecha recordatorio',
          'DELE_DAT_RECOR': 'Eliminando fecha recordatorio',
          'UPDA_DAT_AVI': 'Actualizando fecha aviso',
          'DELE_DAT_AVI': 'Eliminando fecha aviso',
          'CANCELAR_ENVIOS': '¿Está seguro de cancelar el envío de correos electrónicos programados?',
          'CANCELAR_ENVIOS_OK': 'El envío de correos fue cancelado correctamente',
          'CANCELAR_ENVIOS_ERROR': 'No es posible cancelar el envío de correos a menos de dos horas del lanzamiento de la encuesta',
          'COM_CRE_ACCE_WCP_EXT': '¿Está seguro de crear la clave para el  perfil de la empresa?',
          'CRE_ACCE_WCP_EXT': 'Generando clave de acceso',
          'SUCC_CRE_ACCE_WCP_EXT': 'Se genero clave de acceso correctamente',
          'TIT_MOD_VALI_ACCE_WCP_EXT': 'Para continuar: Ingresar la clave de acceso',
          'PLA1_MOD_VALI_ACCE_WCP_EXT': 'Actualmente te quedan ',
          'PLA2_MOD_VALI_ACCE_WCP_EXT': ' intentos',
          'BTN_ACEP': 'Aceptar',
          'BTN_CAN': 'Cancelar',
          'WAR_ACCE_WCP_EXT': 'La clave ingresada no es la correcta',
          'LIMI_ACCE_WCP_EXT': 'Has alcanzado el limite de intentos',
          'DESAC_ACCE_WCP_EXT': 'Actualmente el perfil de empresa se encuentra desactivado',
          'ACTU_ACCE_WCP_EXT': 'Actualizando información',
          'SUCC_ACTU_ACCE_ACCE_WCP_EXT': 'Se actualizo correctamente',
          'CHANGE_WCP':'Cargando perfil de empresa',
        },
        'SUBACCIONES': {
          'TITULO': 'Clic aquí para ver más acciones disponibles',
          'AUDMANUAL': {
            'TITULO': 'Auditoría manual',
            'NOMBRE': 'Nombre del auditor',
            'NOTAS': 'Observaciones',
            'STATUS': {
              'ON': 'Auditoría aceptada',
              'OFF': 'Auditoría rechazada'
            }
          },
          'verRes': {
            'tipoResu': {
              'TITULO': 'Cambiar tipo de versión de resultados',
              'MODAL': {
                'TITULO': 'Selección de tipo de versión',
                'SUBTITULO': 'Seleccione el tipo de versión de resultados para este producto',
                'SINCERT': 'Versión sin certificado',
                'CONCERT': 'Versión con certificado'
              }
            },
            'tipoResuV2': {
              'TITULO': 'Ver resultados versión 2',
            },

          },
          'regCertifi': {
            'logoCert': {
              'TITULO': 'Cambiar logotipo del certificado',
            },
            'previewCert': {
              'TITULO': 'Vista previa del certificado',
            },
            'multiSite': {
              'TITULO': 'Activar texto de certificado multi sitio',
            },
            'multiSiteText': {
              'TITULO': 'Ver texto de certificado multi sitio',
            },
          },
          'upNameIcon': {
            'logoEmpresa': {
              'TITULO': 'Cambiar logotipo de la empresa'
            },
            'previewLogoEmp': {
              'TITULO': 'Vista previa del logotipo'
            },
            'updateDatCerti': {
              'TITULO': 'Cambiar fecha certificado',
            }
          },
          'masterTable': {
            'syncMT': {
              'TITULO': 'Sincronizar Master Table'
            }
          },
          'crearClave': {
            'visibleSwitchWCP': {
              'TITULO': 'Estatus ver perfil de empresa externo',
            }
          },
          'verDatWPC': {
            'visibleSwitchWCP': {
              'TITULO': 'Estatus ver perfil de empresa externo',
            }
          },
          'verWebComPro': {
            'updateStatusWCP': {
              'TITULO': 'Estatus ver perfil de la empresa en la web',
            },
            'ESTA_WPC':{
              'ESTA_WPC_PU':'Publico',
              'ESTA_WPC_NPU':'No publico',
            },
          },
          'cambiaCultureBrief': {
            'TITULO': 'Asociación de Culture Audit Brief',
            'STATUS_SIN': 'Actualmente este producto no cuenta con un producto Culture Audit Brief asociado',
            'STATUS_CON': 'Producto asociado actualmente',
            'BOTON_ELEGIR': 'Asociar un producto Culture Audit Brief',
            'BOTON_ELEGIR_2': 'Confirmar',
            'BOTON_CAMBIAR': 'Asociar a otro producto Culture Audit Brief',
            'LISTA_ELEGIR': 'Elija un producto Culture Brief de la lista',
            'LISTA_DISPONIBLES': 'Productos disponibles',
            'SIN_OPCIONES': 'No hay productos disponibles',
            'MESSAGE3':'<span>Para confirmar la asociación del producto Culture Audit Brief seleccionado, ingrese el texto en rojo en la caja de texto: ',
            'MESSAGE4':'</span>',
            'MESSAGE5':'El producto Culture Audit Brief seleccionado se asoció correctamente con su producto Certificar',
            'VALIDAR': 'Confirmar',
            'SALIR': 'Cancelar',
            'ERRORNOMBREEMPRESA': 'El texto ingresado, no coincide con el texto indicado en rojo',
            'CERRAR': 'Cerrar',
          }
        }
      },
      'HISTORIAL_MAILS': {
        'TAB': 'Historial de correos enviados',
        'TITULO': 'Lista de correos electrónicos enviados para este producto',
        'TABLA': {
          'DESTINATARIO': 'Destinatario',
          'ASUNTO': 'Asunto',
          'ESTADO': 'Estado actual',
          'VECES': 'Número de veces abierto',
          'ULTIMO': 'Fecha del último evento',
          'FILTRO': 'Filtrar',
          'INPUT_DEST': 'Correo a buscar',
          'INPUT_ASU': 'Filtrar por asunto',
          'INPUT_STAT': 'Filtrar por estado',
          'ELIJAOPCION': '- Elija una opción de la lista -',
          'NORESULTS': 'No se encontraron registros',
          'LISTA_STATUS': {
            'delivered': 'Enviado',
            'processed': 'En proceso de envío',
            'not_delivered': 'No enviado'
          }
        },
        'ACCIONES': {
          'TITULO': 'Acciones disponibles',
          'LISTA': {
            'enviaCorreos': 'Enviar correos manualmente',
            'getEnviados': 'Actualizar historial de envíos',
          }
        },
        'MODAL': {
          'TITULO': 'Envio manual de correos',
          'SUBTITULO': 'Puede realizar el envío manual inmediato de los correo de un tipo específico a los colaboradores en esta encuesta',
          'INPUT': 'Seleccione un tipo de correo',
          'TIPOS': {
            '1': 'Correo de invitación',
            '2': 'Correo de recordatorio',
            '3': 'Primer aviso previo a lanzarse la encuesta',
            '4': 'Segundo aviso previo a lanzarse la encuesta',
            '5': 'Correo de cierre',
            '6': 'Correo enviado a los colaboradores que aún no inician la encuesta',
            '7': 'Correo enviado a los colaboradores que iniciaron pero no han terminado'

            //   {tipo: 1}, //invitacon
            //   {tipo: 2}, //recordatorio
            //   {tipo: 3},  //aviso 1
            //   {tipo: 4},  //aviso 2
            //   {tipo: 5},  //cierre
            //   {tipo: 6},  //personalizados aún no inician
            //   {tipo: 7},  //personalizados inican pero aún no acaban
          },
          'BOTONES': {
            'BACK': 'Regresar',
            'CONTINUAR': 'Continuar',
            'SAVE': 'Guardar auditoria',
          }
        },
        'MODALES': {
          'RECUPERANDO': 'Recuperando lista de correos enviados, espere un momento',
          'SEND_EMA':'Enviando  correos',
          'SUCC_SEND_EMA':'Se enviaron los correos correctamente',
          'CONFIRMAR': '¿Confirma enviar los correos del tipo seleccionado a los colaboradores en esta encuesta?',
          'ENVIADOS': 'Los correos se enviaron correctamente, actualice el historial en breve para ver los correos enviados',
          'SI': 'Si',
          'NO': 'No',
          'UPDAT_HIST_EMA': 'Actualizando historial',
          'SUCC_UPDAT_HIST_EMA': 'Se actualizo correctamente',
          'WAR_SEL_MAI': 'Para continuar, seleccionar un tipo de correo',
          'WAR_SQL_ERROR': 'El tiempo de respuesta ha expirado, intente de nuevo',
        },
        'RESUMEN': {
          'TITULO': 'Resumen',
          'TIPOS': {
            'totalEnviados': 'Total de envíos iniciados',
            'delivered': 'Envíos correctos',
            'processed': 'Envíos en proceso',
            'not_delivered': 'Envíos no realizados',
          }
        }
      },
      'AUDITORIA':{
        'TAB_TIT_AUDI':'Auditoría de la encuesta',
        'TEX_AUDI_NOT_AUTORI':'Auditoría rechazada!',
        'TEX_AUDI_YE_AUTORI':'Auditoría aceptada!',
        'TITL_AUDI_DEV_TR':'% Dev.Tiempo Respuesta',
        'TITL_AUDI_DEV_PC':'% Dev. Pregunta Control',
        'TITL_AUDI_DEV_PA':'% Dev. Pregunta Aleatoria',
        'TIT_PAGI_TABL':'Artículos por página:',
        'COLUMNAS':{
          'HierarchicalPath':'Estructura',
          'RespondentCount':'# Respuestas',
          'Time_DeviationCount':'# Desv T.Resp',
          'Time_DeviationPercentage':'% Desv T.Resp',
          'ControlStatement_DeviationCount':'# Desv P.Control',
          'ControlStatement_DeviationPercentage':'% Desv P.Control',
          'RandomStatement_DeviationPercentage':'# Desv P.Aleatoria',
          'RandomStatement_DeviationCount':'% Desv P.Aleatoria',

        }
      },
      'EMAI_LOG':{
        'TAB':'Historial correos general',
        'TABLA_GLOBAL':{
          'TITU':'Visualización global ',
          'SUB_TIT':'Total colaboradores',
          'TH_1':'Estatus',
          'TH_2':'Primer aviso',
          'TH_3':'Segundo aviso',
          'TH_4':'Invitación',
          'TH_5':'Recordatorio usuarios sin comenzar',
          'TH_6':'Recordatorio usuarios sin finalizar',
          'enviados':'Enviados',
          'procesando':'Procesando',
          'error':'Error',
          'VIE_DETA_TOOL':'Ver detalles',

        },
        'TABLA_COLAB':{
          'TITU_AV1_DELIV':'Visualización de correo tipo aviso 1 enviados',
          'TITU_AV1_PROCC':'Visualización tipo de correo  aviso 1 en proceso',
          'TITU_AV1_N_DELIV':'Visualización tipo de correo  aviso 1 en error',
          'TITU_AV2_DELIV':'Visualización de correo tipo aviso 2 enviados',
          'TITU_AV2_PROCC':'Visualización tipo de correo  aviso 2 en proceso',
          'TITU_AV2_N_DELIV':'Visualización tipo de correo  aviso 2 en error',
          'TITU_INV_DELIV':'Visualización de correo tipo invitación enviados',
          'TITU_INV_PROCC':'Visualización tipo de correo  invitación en proceso',
          'TITU_INV_N_DELIV':'Visualización tipo de correo  invitación en error',
          'TITU_REC1_DELIV':'Visualización de correo tipo recordatorio 1 enviados',
          'TITU_REC1_PROCC':'Visualización tipo de correo  recordatorio 1 en proceso',
          'TITU_REC1_N_DELIV':'Visualización tipo de correo  recordatorio 1 en error',
          'TITU_REC2_DELIV':'Visualización de correo tipo recordatorio 2 enviados',
          'TITU_REC2_PROCC':'Visualización tipo de correo  recordatorio 2 en proceso',
          'TITU_REC2_N_DELIV':'Visualización tipo de correo  recordatorio 2 en error',
          'SUB_TIT':'Total colaboradores',
          'TH_1':'Estatus',
          'TH_2':'Nombre colaborador',
          'TH_3':'Mensaje',
          'TH_4':'Fecha ultimo correo',
          'TH_5':'Total correos',
          'TH_6':'Acción',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounced',
          'dropped':'Dropped',
          'TEX_SEARC_COLAB':'Ingrese nombre o correo electrónico',

        },
        'TEX_MOD_CHA_INFO':'Cargando información',
        'CONT_MOD':{
          'TAB_TIT1':'Estatus correos',
          'TAB_TIT2':'Vista correo',
          'TEX_CHA_INFO_GRAL':'Cargando información',
          'TEX_ASUN':'Asunto: ',
          'TEX_SELEC_EMA':'Seleccione un correo electronico',
          'TEX_CHA_INFO_EMA':'Cargando información del correo',
          'H1_TIT_EMA_INFO':'Información por correo electrónico',
          'SPAN_SUB_TIT_DET':'detalles',
          'TO':'A:',
          'FROM':'De:',
          'SUBJE':'Asunto:',
          'MESS_ID':'ID del mensaje:',
          'BTN_VER_MAS':'Más detalles',
          'BTN_VER_MEN':'Menos detalles',
          'TIT_TEX_LIS':'Historia del evento',
          'SPAN_RECIV_SENGR':'Recibido por SendGrid',
          'SPAN_RECIV_FROM':'Recibido por',
         'processed':'Processed',
         'delivered':'Delivered',
         'open':'Open',
         'bounce':'Bounced',
         'dropped':'Dropped',
         'deferred':'Deferred',
         'blocked':'blocked',
         'SPAN_DES_OPE_EMA':'El destinatario abrió este correo',
         'REASON':{
          'Bounced Address':'Dirección rebotada',
         }



        }
      },
      'DAT_CERTI':{
        'TIT_MOD':'Modificar fecha certificado',
        'ING_DAT':'Seleccionar fecha:',
        'ING_RAS':'Ingresar la razon para modificar fecha:',
        'BTN_SAV':'Guardar cambios',
        'BTN_OK':'OK',
        'MOD_ING_REA':'Ingresar la razon del cambio de fecha',
        'MOD_UPD_DAT':'Actualizando fecha certificado',
        'SUCC_MOD_UPD_DAT':'Se actualizo correctamente',

      },
      'DAT_STAEND':{
        'TIT_MOD':'Fecha inicio y termino de encuesta',
        'SUB_TIT_MOD':'Cada fecha se muestra en la hora local en ',
        'TEX_DA_STA':'Fecha inicio',
        'TEX_DA_EN':'Fecha termino',
        'MOD_UPD_DA_STA':'Actualizando fecha de lanzamiento',
        'MOD_UPD_DA_EN':'Actualizando fecha de termino',
        'SUCC_MOD_UPD_DA_STA':'Se actualizo correctamente',
        'SUCC_MOD_UPD_DA_EN':'Se actualizo correctamente',

      },
      'LANG_CERT':{
        'TIT_MOD':'Seleccionar idioma: ',
      },
    }
};
